<template>
  <div class="container mt-lg-5 mb-5">
    <div class="d-flex flex-row align-items-center justify-content-between gap-2 mb-3">
      <div class="d-flex flex-row align-items-center gap-2">
        <router-link to="/personas" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('volver') }}</span>
        </router-link>
        
        <h2 class="m-0">{{ $t('permiso') }}</h2>
        
        <button type="button" @click="isEditing = true" v-if="!isEditing" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" class="stroke-principal" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 21H12" class="stroke-principal" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('editar') }}</span>
        </button>

        <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
      </div>

      <button type="button" @click="eliminarPermiso" class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1" v-if="!loading && !isEditing">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2">
          <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ $t('eliminar') || 'Eliminar Permiso' }}
      </button>
    </div>

    <div>
      <form @submit.prevent="saveChanges" class="d-flex flex-column gap-3">
        
        <div class="fs-7 w-100">
          <strong>{{ $t('nombrePermiso') }}:</strong> 
          <input type="text" v-model="permiso.PermisoNombre" class="form-control sombra-sm mt-1" required :disabled="!isEditing" />
        </div>

        <div class="row">
          <div class="col-md-6 fs-7 mb-2">
            <strong>{{ $t('categoria') }}:</strong>
            <input type="text" v-model="permiso.Categoria" class="form-control sombra-sm mt-1" :disabled="!isEditing" />
          </div>
          <div class="col-md-6 fs-7 mb-2">
            <strong>{{ $t('subCategoria') }}:</strong>
            <input type="text" v-model="permiso.SubCategoria" class="form-control sombra-sm mt-1" :disabled="!isEditing" />
          </div>
        </div>

        <div class="fs-7 w-100">
          <strong>{{ $t('descripcion') }}:</strong> 
          <textarea id="descripcion" v-model="permiso.Descripcion" class="form-control sombra mt-1" style="height: 100px; resize: none;" maxlength="1000" :disabled="!isEditing"></textarea>
          <div class="mt-1 text-end">
            <span class="texto-secundario fs-8">{{ permiso.Descripcion?.length ?? 0 }}/1000 {{ $t('caracteres') }}</span>
          </div>
        </div>

        <hr class="my-2">

        <div class="d-flex flex-column w-100">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <p class="fs-6 m-0">
              <strong>{{ $t('personasAsignadasPorPermiso') }} ({{ personasPorPermiso?.length ?? 0 }}):</strong>
            </p>
          </div>

          <div v-if="isEditing" class="card p-3 mb-3 fondo-secundario sombra-sm texto-principal">
            <label class="fs-8 fw-bold mb-1">{{ $t('asignarNuevaPersona') }}:</label>
            <div class="d-flex gap-2">
              <div class="position-relative w-100">
                <input 
                  type="text" 
                  v-model="searchQuery" 
                  :placeholder="$t('buscarPersona') + '...'" 
                  class="form-control form-control-sm w-100 sombra-sm" 
                  @input="showDropdown = true"
                  @focus="showDropdown = true"
                />
                
                <ul v-if="showDropdown && filteredPersonas?.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%; max-height: 200px; overflow-y: auto;">
                  <li 
                    v-for="persona in filteredPersonas" 
                    :key="persona.IdPersona" 
                    class="list-group-item list-group-item-action d-flex flex-column p-2" 
                    @click="selectPersona(persona)" 
                    style="cursor: pointer;"
                  >
                    <span class="fs-7">{{ persona.Apellido }}, {{ persona.Nombre }}</span>
                  </li>
                </ul>
                
                <ul v-if="showDropdown && searchQuery && filteredPersonas?.length === 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%;">
                  <li class="list-group-item text-muted p-2 fs-8 text-center">
                    {{ $t('sinResultados') }}
                  </li>
                </ul>
              </div>

              <button type="button" @click="agregarPersona" class="btn btn-primary btn-sm fs-8 text-nowrap" :disabled="!selectedPersonaId">
                {{ $t('asignar') }}
              </button>
            </div>
          </div>
          
          <div class="fondo-secundario p-2 rounded sombra-sm" style="max-height: 400px; overflow-y: auto;">
            <ul v-if="personasPorPermiso && personasPorPermiso?.length > 0" class="m-0 p-0">
              <li v-for="persona in personasPorPermiso" :key="persona.IdPersona + '-permiso'" class="bg-transparent d-flex justify-content-between align-items-center p-2 fs-8 border-0">
                <router-link :to="'/personas/verDatosPersona?id='+persona.IdPersona" class="d-flex align-items-center gap-2 text-decoration-none texto-principal">
                  <div class="d-flex align-items-center justify-content-center p-0 overflow-hidden">
                    <img v-if="persona.FotoUrl" :src="persona.FotoUrl" alt="Profile" class="img-responsive" style="width: 36px; height: 36px; border-radius: 50%; object-fit: cover;" />
                    <div v-else class="d-flex align-items-center justify-content-center img-responsive fondo-gris mx-auto" style="width: 36px; height: 36px; border-radius: 50%; padding: 2px;">
                      <i class="bi bi-person-fill texto-principal fs-5"></i>
                    </div>
                  </div>
                  <span>{{ persona.Apellido }}, {{ persona.Nombre }}</span>
                </router-link>

                <div class="d-flex align-items-center gap-3">
                  <span class="texto-secundario fs-9" v-if="persona.FechaHoraAsignacion">
                    {{ $t('asignadoEl') }} {{ formatDate(persona.FechaHoraAsignacion) }}
                  </span>
                  
                  <button v-if="isEditing" type="button" @click="quitarPersona(persona.IdPersona)" class="btn btn-link link-danger p-0 border-0" title="Quitar Permiso">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2">
                      <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </li>
            </ul>

            <p v-else class="texto-secundario m-0 fs-8 text-center py-2">{{ $t('sinPersonasAsignadas') }}</p>
          
          </div>
        </div>
        <div class="d-flex flex-column w-100">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <p class="fs-6 m-0">
              <strong>{{ $t('personasAsignadasPorRol') }} ({{ personasPorRol?.length ?? 0 }}):</strong>
            </p>
          </div>
          <div class="fondo-secundario p-2 rounded sombra-sm" style="max-height: 400px; overflow-y: auto;">
            <ul v-if="personasPorRol && personasPorRol?.length > 0" class="m-0 p-0">
              <li v-for="(persona, index) in personasPorRol" :key="persona.IdPersona + '-rol-' + index" class="bg-transparent d-flex justify-content-between align-items-center p-2 fs-8 border-0">
                <router-link :to="'/personas/verDatosPersona?id='+persona.IdPersona" class="d-flex align-items-center gap-2 text-decoration-none texto-principal">
                  <div class="d-flex align-items-center justify-content-center p-0 overflow-hidden">
                    <img v-if="persona.FotoUrl" :src="persona.FotoUrl" alt="Profile" class="img-responsive" style="width: 36px; height: 36px; border-radius: 50%; object-fit: cover;" />
                    <div v-else class="d-flex align-items-center justify-content-center img-responsive fondo-gris mx-auto" style="width: 36px; height: 36px; border-radius: 50%; padding: 2px;">
                      <i class="bi bi-person-fill texto-principal fs-5"></i>
                    </div>
                  </div>
                  <span>{{ persona.Apellido }}, {{ persona.Nombre }}</span>
                </router-link>

                <div class="d-flex align-items-center gap-3">
                  <span class="texto-secundario fs-9" v-if="persona.FechaHoraAsignacion">
                    {{ $t('asignadoEl') }} {{ formatDate(persona.FechaHoraAsignacion) }}
                  </span>
                  
                  <button v-if="isEditing" type="button" @click="quitarPersona(persona.IdPersona)" class="btn btn-link link-danger p-0 border-0" title="Quitar Permiso">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2">
                      <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </li>
            </ul>

            <p v-else class="texto-secundario m-0 fs-8 text-center py-2">{{ $t('sinPersonasAsignadas') }}</p>
          
          </div>

          <div class="d-flex flex-row gap-2">
            <button class="btn btn-success mt-2" type="submit" v-if="isEditing">{{ $t('guardar') }}</button>
            <button class="btn btn-secondary mt-2" type="button" @click="cancelarEdicion" v-if="isEditing">{{ $t('cancelar') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'EditarPermiso',
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();

    const isEditing = ref(false);
    const loading = ref(false);
    
    // Variables para el buscador reactivo
    const selectedPersonaId = ref('');
    const searchQuery = ref('');
    const showDropdown = ref(false);
    const todasLasPersonas = ref([]); 

    const permiso = ref({
      PermisoNombre: '',
      Descripcion: '',
      Categoria: '',
      SubCategoria: '',
      PersonasAsignadas: []
    });
    
    let backupPermiso = {};

    // 1. Filtrado de personas disponibles en el universo total del sistema (que no tengan ya el permiso)
    const personasDisponibles = computed(() => {
      if (!todasLasPersonas.value?.length) return [];
      const asignadasIds = permiso.value.PersonasAsignadas.map(p => p.IdPersona?.toLowerCase());
      return todasLasPersonas.value.filter(p => !asignadasIds.includes(p.IdPersona?.toLowerCase()));
    });

    // Separar personas con asignación directa
    const personasPorPermiso = computed(() => {
      if (!permiso.value.PersonasAsignadas) return [];
      return permiso.value.PersonasAsignadas.filter(p => p.Origen === 'Permiso');
    });

    // Separar personas que obtienen el permiso por Rol
    const personasPorRol = computed(() => {
      if (!permiso.value.PersonasAsignadas) return [];
      return permiso.value.PersonasAsignadas.filter(p => p.Origen === 'Rol');
    });
    // 2. Filtrado interactivo por el texto ingresado en el buscador (aplica sobre las personas disponibles)
    const filteredPersonas = computed(() => {
      if (!searchQuery.value) return personasDisponibles.value;
      const query = searchQuery.value.toLowerCase();
      return personasDisponibles.value.filter(p => {
        const nombreCompleto = `${p.Nombre} ${p.Apellido}`.toLowerCase();
        const apellidoNombre = `${p.Apellido} ${p.Nombre}`.toLowerCase();
        return nombreCompleto.includes(query) || apellidoNombre.includes(query);
      });
    });

    // 3. Acción cuando el usuario selecciona una persona de la lista de sugerencias
    const selectPersona = (persona) => {
      searchQuery.value = `${persona.Apellido}, ${persona.Nombre}`;
      selectedPersonaId.value = persona.IdPersona;
      showDropdown.value = false;
    };

    const fetchPermisoDetalle = async () => {
      try {
        loading.value = true;
        const idPermiso = route.query.id; 
        if (!idPermiso) {
          console.error("Falta el ID del permiso en la URL");
          await router.push('/personas/permisos');
          return;
        }

        const response = await api.get(`api/permisos/${idPermiso}`);
        permiso.value = response.data;
        console.log(permiso.value);
        backupPermiso = JSON.parse(JSON.stringify(response.data)); 
      } catch (error) {
        console.error('Error al obtener datos del permiso:', error);
      } finally {
        loading.value = false;
      }
    };

    const fetchTodasLasPersonas = async () => {
      try {
        const response = await api.get('api/Persona/ByRole?role=Empleado'); 
        todasLasPersonas.value = Array.isArray(response.data) ? response.data : response.data.items || [];
      } catch (error) {
        console.error('Error al obtener lista global de personas:', error);
      }
    };

    const agregarPersona = async () => {
      if (!selectedPersonaId.value) return;
      const idPermiso = route.query.id;

      try {
        loading.value = true;
        await api.post('api/permisos/assign', {
          PersonaId: selectedPersonaId.value,
          PermisoId: idPermiso
        });
        
        // Limpiamos los campos del buscador tras una asignación exitosa
        selectedPersonaId.value = '';
        searchQuery.value = '';
        
        await fetchPermisoDetalle();
      } catch (error) {
        console.error('Error al asignar persona:', error);
        alert(error.response?.data || 'No se pudo asignar la persona.');
      } finally {
        loading.value = false;
      }
    };

    const quitarPersona = async (IdPersona) => {
      const idPermiso = route.query.id;
      if (confirm(t('confirmarQuitarPersona'))) {
        try {
          loading.value = true;
          await api.delete('api/permisos/unassign', {
            data: {
              PersonaId: IdPersona,
              PermisoId: idPermiso
            }
          });
          await fetchPermisoDetalle();
        } catch (error) {
          console.error('Error al quitar persona:', error);
          alert(error.response?.data || 'No se pudo desasignar la persona.');
        } finally {
          loading.value = false;
        }
      }
    };

    const saveChanges = async () => {
      try {
        loading.value = true;
        const idPermiso = route.query.id;

        const data = {
          PermisoNombre: permiso.value.PermisoNombre || null,
          Descripcion: permiso.value.Descripcion || null,
          Categoria: permiso.value.Categoria || null,
          SubCategoria: permiso.value.SubCategoria || null
        };

        await api.put(`api/permisos/${idPermiso}`, data);
        
        isEditing.value = false;
        backupPermiso = JSON.parse(JSON.stringify(permiso.value));
        alert(t('guardadoExitoso') || 'Permiso actualizado correctamente.');
      } catch (error) {
        console.error('Error al guardar los cambios del permiso:', error);
        alert(t('errorGuardar') || 'Hubo un problema al guardar los datos.');
      } finally {
        loading.value = false;
      }
    };

    const cancelarEdicion = () => {
      permiso.value = JSON.parse(JSON.stringify(backupPermiso));
      selectedPersonaId.value = '';
      searchQuery.value = '';
      isEditing.value = false;
    };

    const eliminarPermiso = async () => {
      const idPermiso = route.query.id;
      const mensajeConfirmacion = t('confirmarEliminarPermiso') || '¿Estás seguro de que deseas eliminar este permiso? Esto removerá todas las asignaciones vinculadas a personas de forma permanente.';
      
      if (confirm(mensajeConfirmacion)) {
        try {
          loading.value = true;
          await api.delete(`api/permisos/${idPermiso}`);
          await router.push('/personas/permisos');
        } catch (error) {
          console.error('Error al eliminar el permiso:', error);
          alert(t('errorEliminar') || 'Ocurrió un error al intentar eliminar el permiso.');
        } finally {
          loading.value = false;
        }
      }
    };

    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    };

    onMounted(() => {
      fetchPermisoDetalle();
      fetchTodasLasPersonas();
    });

    return {
      t,
      permiso,
      isEditing,
      loading,
      selectedPersonaId,
      searchQuery,
      showDropdown,
      personasDisponibles,
      filteredPersonas,
      selectPersona,
      agregarPersona,
      quitarPersona,
      saveChanges,
      cancelarEdicion,
      eliminarPermiso,
      formatDate,
      personasPorPermiso,
      personasPorRol,
    };
  }
};
</script>

<style scoped>
.fs-9 {
  font-size: 0.75rem;
}
</style>